import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import LazyImage from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    bannerHeading = "bannerHeading",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.bannerHeading]: string;
    };
    extendedStyles?: CENArticlesBannerStyles;
}

export interface CENArticlesBannerStyles {
    bannerWrapper?: InjectableCss;
    quoteImage?: InjectableCss;
    bannerHeading?: InjectableCss;
}

export const CENarticlesBannerStyles: CENArticlesBannerStyles = {
    bannerWrapper: {
        css: css`
            margin-bottom: 56px;
            display: flex;
            flex-direction: column;
        `,
    },
    quoteImage: {
        css: css`
            img {
            width: 100%;
            height: auto;
            }
        `,
    },
    bannerHeading: {
        css: css`
            margin-top: 8px;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: 20px;
            font-weight: ${TYPOGRAPHY.weight.baseBold} !important;
        `,
    },
};

const styles = CENarticlesBannerStyles;
type Props = WidgetProps;

export const CENArticlesBanner: FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.bannerWrapper}>
            <LazyImage className="CENImg" src={fields.image} altText={fields.bannerHeading} {...styles.quoteImage} />
            <Typography variant="p" {...styles.bannerHeading}>
                {translate("{0}",fields.bannerHeading)}
            </Typography>
        </StyledWrapper>
    );
};

const ArticlesBanner: WidgetModule = {
    component: CENArticlesBanner,
    definition: {
        group: "Common",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Quote Image",
            },
            {
                name: fields.bannerHeading,
                displayName: "Banner Heading",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default ArticlesBanner;
